<template>
  <el-table-column label="#" width="120">
    <template slot-scope="scope">
      <el-button
        type="info"
        icon="el-icon-edit"
        @click="edit(scope.$index, scope.row)"
        circle
      ></el-button>
      <el-button
        type="danger"
        icon="el-icon-delete"
        @click="remove(scope.$index)"
        circle
      ></el-button>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: 'TableColumnButton',
  props: ['message'],
  methods: {
    edit(index, data) {
      this.$emit("edit", index, data)
    },
    remove(index) {
      this.$emit("remove", index)
    }
  }
}
</script>